
import {isUndefined} from 'lodash'
import utils from '@ykcl/utils'
interface timeInt{
  day:string
  hour: string,
  minute: string,
  second:string
}
/**
 * 
 * startTime : 传入的开始时间
 * endTime : 传入的结实时间
 * duration : 传入的间隔时间
 * backTime : 进行中的回调方法
 * endFun：结束的回调方法
 */
export const countDown = (startTime,endTime,duration:1000,backTime,endFun)=>{
  if(!startTime || isUndefined(startTime) || !endTime){
   return 
  }
 let timeObj:timeInt={
   day:"00",
   hour: '00',
   minute: '00',
   second:'00'
 }
 let timer = null
 clearInterval(timer)
 // console.log(11111)
 let surplusTime:number = Number(endTime/1000)-Number(startTime/1000)

 if(surplusTime && surplusTime<=0) return
 timer = setInterval(async ()=>{
   surplusTime = surplusTime -1
   if(surplusTime<=0) {
     clearInterval(timer)
     endFun
     timer = null
     return timeObj;
   }
   timeObj = await timeFormat(surplusTime)
   backTime(timeObj)
  },duration)
  
}

const timeFormat = (timeNu)=>{
 let timeObj:timeInt={
   day:"00",
   hour: '00',
   minute: '00',
   second:'00'
   
 }
 // console.log(timeNu/60/60/24,3333333)
 timeObj.day =  String(parseInt( timeNu/60/60/24 )).padStart(2,'0');//天
 timeObj.hour=  String(parseInt( timeNu/60/60%24 )).padStart(2,'0');//时
 timeObj.minute =  String(parseInt( timeNu/60%60 )).padStart(2,'0');//分
 timeObj.second =  String(parseInt( timeNu%60 )).padStart(2,'0');//秒
 return timeObj
}